/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {copyToClipboard} from "utils/utility";
import Skeleton from "react-loading-skeleton";

interface BookingLoginReservationDetailFieldProps {
    label?: string;
    value: string | number | null;
    name: string;
    className?: string;
    classNameInput?: string;
}

const BookingLoginReservationDetailField = (props: BookingLoginReservationDetailFieldProps) => {
    return (
        <div className={clsx("BookingLoginReservationDetailField text-xs md:text-[20px] md:leading-normal inline-flex gap-2 items-center", props.className)}>
            {props.label && (
                <label className="  text-gray-900" htmlFor={"input_" + props.name}>
                    <span>{props.label}:</span>
                </label>
            )}
            <div className={clsx("text-black font-semibold", props.classNameInput)} onClick={() => copyToClipboard(props.value ? "" + props.value : "N/A")}>
                {props.value ? props.value : <Skeleton width={"4rem"} />}
            </div>
        </div>
    );
};

export default BookingLoginReservationDetailField;
